import { Record } from 'immutable';

const SaveNewQuoteModelV25 = Record({
    leadId: 0,
    accountId: 0,
    year: 0,
    make: '',
    model: '',
    vehicleCondition: '',
    modelTrimCode: '',
    configurationId: 0,
    showroomVehicleId: '',
    vehicleId: 0,
    vin: '',
    stockNumber: '',
    saleType: 'retail',
    taxPlan: 'standard',
    odometer: 0,
    purchaseMethod: 'cash',
    financePlan: '',
    kmPerYearPlan: 0,
    paymentFrequency: 12,
    term: 0,
    cashDown: 0,
    tradeIn: 0,
    lien: 0,
    transactionTokenCopy: '',
    transactionToken: '',
    sellingPrice: 0,
    retail: 0,
});

export default SaveNewQuoteModelV25;
